import React, {useEffect, useMemo, useState} from 'react';
import '../style.css'
import {
    TestAudio
} from "../../../../students-test/separate-test/separate-test-table/test-tabs/test-table/test-audio/Test-audio";
import {TestItem} from "features/model/slice/create-test/create-test-form/createTestForm";
import {useAppDispatch, useAppSelector} from "common/hook";
import {
    ReactComponent as DisabledIcon
} from '../../../../../../../assets/main/test/response/text-questions/disabled.svg';
import {ReactComponent as CorrectIcon} from '../../../../../../../assets/main/test/response/text-questions/correct.svg';
import {ReactComponent as WrongIcon} from '../../../../../../../assets/main/test/response/text-questions/wrong.svg';
import {useAnswerCorrectness} from "common/hook/useAnswerCorrectness";
import {
    incrementCorrectTestCount,
    resetCorrectTestCount
} from "features/model/slice/test/correct-test/correctTestSlice";


interface IQuestionOptions {
    testItem: TestItem
    index:number;
}


export const AuditionTitle: React.FC<IQuestionOptions> = React.memo(({ testItem,index }) => {
    const resultData = useAppSelector(state => state.testViewAnswerId.serverData?.data?.result);
    const dispatch = useAppDispatch();

    const [correctAnswersCount,setCorrectAnswersCount]= useState(0)

const { isAnswerCorrect } = useAnswerCorrectness(testItem.answers, testItem.id);

    useEffect(() => {
        // Проверяем совпадение ответов ученика и учителя
        if (isAnswerCorrect) {
            const newCorrectAnswersCount = testItem.answers.reduce((count, answer) => {
                if (answer.isCorrect) {
                    const studentAnswer = resultData?.answers?.find(
                        (el) => el.questionId === testItem.id && el.answerId === answer.id
                    );
                    const isCorrect = !!studentAnswer;
                    if (isCorrect) {
                        return count + 1;
                    }
                }
                return count;
            }, 0);

            setCorrectAnswersCount(newCorrectAnswersCount);
            dispatch(incrementCorrectTestCount(newCorrectAnswersCount));
        }
    }, [isAnswerCorrect, resultData, testItem.answers, testItem.id]);


    const containerClass = `test-descr-item answered ${correctAnswersCount ? '' : 'error'}`;

    return (
        <div className={containerClass}>
            <p className="h4 test-descr-title">
                <span className="index-num">{++index}</span>
                {testItem.questionTitle}
            </p>
            <TestAudio audioUrl={testItem?.file?.path}/>
            <div className="radio-group in-cols">
                {testItem.answers.map(answer => {
                    const isTeacherAnswerCorrect = answer.isCorrect;
                    const studentAnswer = resultData?.answers.find(el =>
                        el.questionId === testItem.id && el.answerId === answer.id
                    );

                    return (
                        <div className="col" key={answer.id}>
                            <div
                                className={`radio-item ${isTeacherAnswerCorrect ? 'selected correct-answer' : (studentAnswer ? 'incorrect-answer' : '')}`}
                            >
                                <input
                                    id={`answer-option-inp${testItem.id}-${answer.id}`}
                                    name={`radioGroup-${testItem.id}`}
                                    type="radio"
                                />
                                <label htmlFor={`answer-option-inp${testItem.id}-${answer.id}`}>
                                    <span className="p-icon">
                                      {answer.text}
                                    </span>
                                    <span className="icon icon-posit">
                                             {isTeacherAnswerCorrect ? <CorrectIcon/> : (studentAnswer ? <WrongIcon/> :
                                                 <DisabledIcon/>)}
                                    </span>
                                </label>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
});

